import axios from "axios";
import {
    COLLEGE_LIST_REQUEST,
    COLLEGE_LIST_SUCCESS,
    COLLEGE_LIST_FAIL,
    COLLEGE_LIST_TOTAL_REQUEST,
    COLLEGE_LIST_TOTAL_SUCCESS,
    COLLEGE_LIST_TOTAL_FAIL,
    COLLEGE_CREATE_REQUEST,
    COLLEGE_CREATE_SUCCESS,
    COLLEGE_CREATE_FAIL,
    COLLEGE_GET_REQUEST,
    COLLEGE_GET_SUCCESS,
    COLLEGE_GET_FAIL,
    COLLEGE_UPDATE_SUCCESS,
    COLLEGE_UPDATE_REQUEST,
    COLLEGE_UPDATE_FAIL,
    COLLEGE_DELETE_REQUEST,
    COLLEGE_DELETE_SUCCESS,
    COLLEGE_DELETE_FAIL
} from '../constants/collegeConstants'
import API from '../core/api';

export const listColleges = (collegeJson) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_LIST_REQUEST })

        const { data } = await API.post(
            `/university/getUniversities`,
            collegeJson
        )
            
        var dt = data.Result;
        if(typeof(dt)=='string'){
            dispatch({
                type: COLLEGE_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: COLLEGE_LIST_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: COLLEGE_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const listTotalColleges = (searchJson) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_LIST_TOTAL_REQUEST })
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        }

        const { data } = await API.post(
            `/university/getUniversitiesTotal`,
            searchJson,
            config
        )

        dispatch({
            type: COLLEGE_LIST_TOTAL_SUCCESS,
            payload: data.Result
        })
    } catch (error) {
        dispatch({
            type: COLLEGE_LIST_TOTAL_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const createColleges = (universityJson) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_CREATE_REQUEST })

        const { data } = await API.post(
            `/university`,
            universityJson
        )

        var dt = data.Result;

        if (dt.includes("Error")) {
            dispatch({
                type: COLLEGE_CREATE_FAIL,
                payload: data.Result
            })
        } else {
            dispatch({
                type: COLLEGE_CREATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: COLLEGE_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const detailColleges = (Id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_GET_REQUEST })
        const { data } = await API.get(
            "/university/" + Id
        )

        var dt = data.Result;

        if (typeof (dt) == 'string') {
            dispatch({
                type: COLLEGE_GET_FAIL,
                payload: data.Result
            })
        } else {
            dispatch({
                type: COLLEGE_GET_SUCCESS,
                payload: data.Result
            })
        }

    } catch (error) {
        dispatch({
            type: COLLEGE_GET_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const updateColleges = (Id, universityJson) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_UPDATE_REQUEST })

        const { data } = await API.put(
            "/university/" + Id,
            universityJson
        )

        var dt = data.Result;

        if(dt.includes("Error")){
            dispatch({
                type: COLLEGE_UPDATE_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: COLLEGE_UPDATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: COLLEGE_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const deleteColleges = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COLLEGE_DELETE_REQUEST })
        const { data } = await API.delete(
            `/university/` + id
        )

        var dt = data.Result;

        if (dt.includes("Error")) {
            dispatch({
                type: COLLEGE_DELETE_FAIL,
                payload: data.Result
            })
        } else {
            dispatch({
                type: COLLEGE_DELETE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: COLLEGE_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}